import { useCallback, useRef } from 'react';

/**
 * @param callback пользовательская функция для срабатывания
 * @param delay задержка с которой будет срабатывать пользовательская функция
 * @returns функция вызова с пользовательской логикой
 */
export default function useDebounce<P extends any[]>(
  callback: (...args: P) => void,
  delay?: number
) {
  const timoutID = useRef<NodeJS.Timeout | null>(null);

  return useCallback(
    (...args: P) => {
      if (timoutID.current !== null) {
        clearTimeout(timoutID.current);
      }

      timoutID.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );
}
